Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultArgOptions = void 0;
exports.defaultArgOptions = {
    isNullable: false
};
//# sourceMappingURL=options.js.map